// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"1858fb46","6":"5385d60e","44":"66695e3d","73":"03c6d11a","453":"c919106f","454":"73a741a0","478":"dcaa59fb","493":"ea920642","506":"8ab8c83e","619":"27be4105","675":"fa6e4e8c","686":"3501834d","823":"129ea495","938":"8aeea199"}[chunkId] + ".chunk.js";
};